import React 				from 'react'
import ReactDOM         	from 'react-dom'
import classnames 			from 'classnames'
import requestFrame    		from 'request-frame'
import getNodeDimensions 	from 'get-node-dimensions'
import { isFinite } 		from 'lodash'
import { connect } 			from 'react-redux'
import PS 					from 'publish-subscribe-js'
import {
	mapRange
} from 'canvas-sketch-util/math'

import {
	delayedVariable,
	roundTo
} from '../../lib/mathHelpers'
import breakpoints from '../../lib/constants/breakpoints.json'

import {
	RESIZE,
	SCROLL
} from '../../lib/pubSubEvents'

class ParallaxEl extends React.Component {
	constructor(props) {
		super(props)

        this.checkScrollUpdate = this.checkScrollUpdate.bind(this)
        this.loopStep = this.loopStep.bind(this)

        this.perc = 0

        this.state = {
			delayedPerc: 0
		}
	}

	componentDidMount() {
		this.resizeKey = PS.subscribe(RESIZE, this.checkScrollUpdate)
		this.scrollKey = PS.subscribe(SCROLL, this.checkScrollUpdate)

		this.checkScrollUpdate()

		this.nextLoop()
	}

	componentWillUnmount() {
		if(this.resizeKey){ PS.unsubscribe(RESIZE, this.resizeKey) }
		if(this.scrollKey){ PS.unsubscribe(SCROLL, this.scrollKey) }
        
        const cancel = requestFrame('cancel')
        if(this.loopStepLoopID){ cancel(this.loopStepLoopID) }
	}

    nextLoop(){
		const request = requestFrame('request')
        this.loopStepLoopID = request(this.loopStep)
    }

	checkScrollUpdate(){
		const {
			screenSize
		} = this.props
		
		const wrapEl = ReactDOM.findDOMNode(this)
    	const wrapElDimensions = getNodeDimensions(wrapEl)

    	const windowHeight = screenSize.height

    	const minTop = windowHeight
    	const maxTop = wrapElDimensions.height * -1

    	const perc = Math.min(1, Math.max(0,
    		mapRange(wrapElDimensions.top, minTop, maxTop, 0, 1)
    	))

    	this.perc = perc
	}

	loopStep(){
    	const {
    		delayedPerc
    	} = this.state

    	const _delayedPerc = delayedVariable(delayedPerc, this.perc, this.getDelaySpeed(), 10000)
		if(delayedPerc !== _delayedPerc){
			this.setState({
				delayedPerc: _delayedPerc
			})
		}

		this.nextLoop()
    }

    getSpeed(){
    	const { speed } = this.props

		let _speed = speed
		if(!isFinite(speed)){
			_speed = 0.2
		}

		return _speed
    }

    getDelaySpeed(){
    	const { delaySpeed } = this.props

    	let _delaySpeed = delaySpeed
    	if(!isFinite(delaySpeed)){
			_delaySpeed = 0.07
		}

		return _delaySpeed
    }

	render() {
		const {
			className,
			children,
			stretch,
			screenSize
		} = this.props
		const {
			delayedPerc
		} = this.state

		const isMobile = screenSize.width <= breakpoints.mobile
		
		const speed = this.getSpeed()
		const windowHeight = isMobile ? Math.min(screenSize.height, 200) : screenSize.height

		const offset = mapRange(delayedPerc, 0, 1, windowHeight * speed, windowHeight * -1 * speed)
		const translate = `translate3d(0,${ roundTo(offset, 1000) }px,0)`
		const transform = {
			WebkitTransform: translate,
			transform: translate
		}

		return <div className={ classnames('parallaxEl', {
				'parallaxEl--stretch': !!stretch
			}, className) }>
			<div className="parallaxEl-transformWrap"
				style={ transform }>
				{ children }
			</div>
		</div>
	}

}

const mapStateToProps = (state) => {
	const {
		ui
	} = state

	return {
		screenSize: ui.screenSize
	}
}

export default connect(mapStateToProps)(ParallaxEl)